<template v-show="show">
    <div>
      <template v-if="selectedBettype.tmpltId == '8' || hotSchedule == true">
        <template v-if="selectedBettype.sprtId == 'N2' || ( hotSchedule == true && event.sptid == 2)"> <!-- basketball -->
          <div v-if="checkAnyExist(event)">
            <!-- More Bet Type Row -->
            <div class="other-play-tab">
              <div class="play-title col">
                <div class="arrow-wrap yb-flex-center" @click="openMoreBetForm(event,'arrow')">
                  <div class="yb-icon-arrow" :id="'moreBet' + event.eveid" :class="{ active: !showMoreBet }"></div>
                </div>
                <div class="tab-wrap fit relative-position">
                  <div id="more-tab" class="item-wrap relative-position" style="left: 0px;">

                    <template v-if="hotSchedule == true" v-for="tabkey in sportTabs['N'+event.sptid]">
                        <div v-if="checkMBTexist(event, tabkey)" class="tab-item yb-flex-center" :class="[tabkey + 'tab-' + event.eveid, { active: setTabActive(event) == 1 }]"
                        @click="chooseMarketType(mBetTab[tabkey], event, '.' + tabkey + 'tab-' + event.eveid)">{{
                            sportAllBetLang['ALL_BET.LBL_'+tabkey] }}
                        </div>
                    </template>

                    <template v-else v-for="tabkey in sportTabs[selectedBettype.sprtId]">
                        <div v-if="checkMBTexist(event, tabkey)" class="tab-item yb-flex-center" :class="[tabkey + 'tab-' + event.eveid, { active: setTabActive(event) == 1 }]"
                        @click="chooseMarketType(mBetTab[tabkey], event, '.' + tabkey + 'tab-' + event.eveid)">{{
                            sportAllBetLang['ALL_BET.LBL_'+tabkey] }}
                        </div>
                    </template>

                  </div>
                </div>
              </div>
              <div class="media-col" style="min-width: 41px !important;"></div>
            </div>
            <template v-if="showMoreBet">
              <!-- Header -->
              <!-- <div class="fifteen-box" :ref="'showmoreBet' + event.eveid">
                <div class="basic-col" :style="{ width: widthColumn[0] + 'px !important' }"></div>
                <mbHeader :event="filteredMainMarketList" :selMarket="selectedMarket" :widthColumn="widthColumn" :isUnfold="isUnfold"></mbHeader>
              </div> -->
              <!-- Odds -->
              <div class="match-handicap-item other-handicap-item" :ref="'moreBetmatches' + event.eveid">
                <template v-if="!moreBetLoading">
                  <!-- <sportTeam :event="filteredMainMarketList" :selMarket="selectedMarket" :mode="'morebet'" :widthL="widthColumn[0]"></sportTeam> -->
                  <template v-if="(selectedMarket ==  mBetTab.EG.key)">
                    <moreEG :event="filteredMainMarketList" :widthColumn="widthColumn(false,5)" :isUnfold="isUnfold"></moreEG>
                  </template>
                  <div class="media-col"></div>
                </template>
              </div>
  
            </template>
          </div>
        </template>
      </template>
    </div>
  </template>
  
  <script>
  import {
    mapGetters,
  } from 'vuex'
  import vueCookie from 'vue-cookie'
  import mbHeader from './more-bet-header'
  import sportTeam from '../sportTeamColumn'
  import moreEG from './moreBet-eg'
  import allBetMixin from '../../../mixins/allBet'
  
  export default {
    mixins: [allBetMixin],
    components: {
      mbHeader,
      sportTeam,
      moreEG,
    },
    props: {
      event: null,
      isUnfold:false,
    },
    computed: {
      ...mapGetters([
        'eventAllBet',
        'selectedShow',
        'selectedBettype',
        'moreBetLoading',
        'moreBetToggle',
        'myMarketList',
        'firstEvent',
        'simpleSport',
        'hotSchedule',
      ]),
      filteredMainMarketList() {
        // Filter more bet bet type odd 
        let vue = this
        var eventAllBet = _.cloneDeep(this.event)
        if (vue.selectedMarket) {
            _.forEach(vue.plyTypes, function (plytyp) {
                if(eventAllBet.od[plytyp])
                    eventAllBet.od[plytyp] = _.pick(eventAllBet.od[plytyp], vue.mBetTab[vue.selectedMarket].value);
            })
        }
        return eventAllBet
      },
      sortedMatchEventList: {
        get() {
          this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)
          return this.$store.getters.sortedMatchEventList
        },
        set(value) {
        }
      },
    },
    updated() {
    },
    data() {
      return {
        lang: window.lang,
        plyTypes: [allBetMixin.data().ftPlyType, allBetMixin.data().firstHtPlyType, allBetMixin.data().SecondHtPlyType], // ['1','2','19']
        sportTabs: {
            N2: ['EG'], // bk more bet included bt
        },
        mBetTab: {
            EG: {
                key: 'EG',
                value: [allBetMixin.data().edgBetType], //'74' allBetMixin.data().edgBetType
                flag: true,
            },
        },
        mainMarketList: null,
        showMyMarkets: false,
        showMainMarkets: true,
        allBetRefreshTimer: 90,
        allBetTimerId: null,
        selectedMarket: null,
        token: window.token,
        isRB: false,
        showMoreBet: false,
        show: true,
        childHeight: 0,
        clickMoreBet: false, 
        moreBetmatchesHeight: 0,
        xParent1:0,
        xParent2:0,
      }
    },
    methods: {
      checkAnyExist(event) {
        let vue = this
        let exist = false
        let tabArray = []
        if(vue.hotSchedule == true){
          tabArray = vue.sportTabs['N2']
        }else{
          tabArray = vue.sportTabs[vue.selectedBettype.sprtId]
        }
        let btArray = []
  
        _.forEach(tabArray, function (tab) {
            if(vue.mBetTab[tab]) {
                btArray = btArray.concat(vue.mBetTab[tab].value)
            }
        })

        if(!_.isNull(btArray)) {
            _.forEach(event.od, function (data, key) {
                _.forEach(data, function (val, k) {
                    if ($.inArray(k, btArray) > -1) {
                        exist = true
                    }
                })
            })
        }

        this.show = (exist) ? true : false
        return exist
      },
      checkMBTexist(event, btKey) {
        let vue = this
        let exist = false
        let btArray = vue.mBetTab[btKey].value
  
        _.forEach(event.od, function (data, key) {
          _.forEach(data, function (val, k) {
            if ($.inArray(k, btArray) > -1) {
              exist = true
            }
          })
        })

        return exist
      },
      setTabActive(event){
        let vue = this
        let existCs = 0
  
        _.forEach(event.od, function (data, key) {
          _.forEach(data, function (val, k) {
            _.forEach(vue.sportTabs[vue.selectedBettype.sprtId], function (tabkey) {
                if ($.inArray(k, vue.mBetTab[tabkey].value) > -1) {
                    if(vue.selectedMarket != vue.mBetTab[tabkey].key) vue.selectedMarket = vue.mBetTab[tabkey].key
                    existCs = 1;
                    return false;
                }
            })
          })
        })
  
        return existCs
  
      },
      openMoreBetForm(event,clickFrom) {
        let vue = this
        var expanded = $('#moreBet' + event.eveid).hasClass('active')
        var mbetHeader = 0
  
        _.forEach(vue.sportTabs[vue.selectedBettype.sprtId], function (tabkey) {
            if($('.' + tabkey + 'tab-' + event.eveid).hasClass('active')) {
                vue.selectedMarket = vue.mBetTab[tabkey].key
                return false
            }
        })
  
        if (expanded) {
          // this.$store.commit('MOREBETLOADING', true)
          this.$store.dispatch('getSportAllBet', {
            event: event,
            token: token.arr_8,
            callback: ((res) => {
              this.showMoreBet = true
              this.clickMoreBet = true
              // this.$store.commit('MOREBETLOADING', false)
              this.$nextTick(() => {
                if (this.showMoreBet && this.clickMoreBet) {
                  this.xParent1 = (this.$parent.$refs['eCardWrap'+this.event.eveid] && this.$parent.$refs['eCardWrap'+this.event.eveid].length > 0)? this.$parent.$refs['eCardWrap'+this.event.eveid][0].offsetHeight:this.$parent.$refs['eCardWrap'+this.event.eveid].offsetHeight  //285
                  this.xParent2 = (this.$parent.$refs['eCard'+this.event.eveid] && this.$parent.$refs['eCard'+this.event.eveid].length > 0)? this.$parent.$refs['eCard'+this.event.eveid][0].offsetHeight:this.$parent.$refs['eCard'+this.event.eveid].offsetHeight //285
                  this.childHeight = this.$refs['moreBetmatches'+this.event.eveid].offsetHeight + mbetHeader
                  var p1 = this.xParent1 + this.childHeight
                  var p2 = this.xParent2 + this.childHeight
                  document.getElementById('eCardWrap'+this.event.eveid).style.height = p1+"px";
                  document.getElementById('eCard'+this.event.eveid).style.height = p2+"px";
                  this.clickMoreBet = false
                }
              })
            }).bind(this)
          })
        } else {
          if(clickFrom == 'arrow'){
            //only click the arrow able to hide the more bet form
            this.showMoreBet = false
          }
          if(this.showMoreBet && !this.clickMoreBet){
            this.$nextTick(() => {
              //   var moreBetmatches = this.$refs['moreBetmatches' + this.event.eveid];
              //   this.moreBetmatchesHeight = moreBetmatches ? moreBetmatches.offsetHeight : 0;
              var p1 = $('#eCard'+this.event.eveid).children().height() + 6;
              var p2 = $('#eCard'+this.event.eveid).children().height() + 3;
  
              document.getElementById('eCardWrap'+this.event.eveid).style.height  = p1+"px";
              document.getElementById('eCard'+this.event.eveid).style.height      = p2+"px";
            });
          }else if (!this.showMoreBet && !this.clickMoreBet) {
            var xParent1    = (this.$parent.$refs['eCardWrap'+this.event.eveid] && this.$parent.$refs['eCardWrap'+this.event.eveid].length > 0)? this.$parent.$refs['eCardWrap'+this.event.eveid][0].offsetHeight:this.$parent.$refs['eCardWrap'+this.event.eveid].offsetHeight
            var xParent2    = (this.$parent.$refs['eCard'+this.event.eveid] && this.$parent.$refs['eCard'+this.event.eveid].length > 0)? this.$parent.$refs['eCard'+this.event.eveid][0].offsetHeight:this.$parent.$refs['eCard'+this.event.eveid].offsetHeight
            var childHeight = this.$refs['moreBetmatches'+this.event.eveid].offsetHeight + mbetHeader
            var p1          = xParent1 - childHeight
            var p2          = xParent2 - childHeight
            document.getElementById('eCardWrap'+this.event.eveid).style.height = p1+"px";
            document.getElementById('eCard'+this.event.eveid).style.height = p2+"px";
            this.clickMoreBet = false
          }
        }
      },
      backToTop() {
        document.getElementById("more_div").scrollTop = "0";
      },
      updateFavCookie(plytyp, bettyp, isDelete, isSpecial = false) {
        var favCookie = {}
        if (vueCookie.get(window.compcode + '_fav')) {
          favCookie = JSON.parse(vueCookie.get(window.compcode + '_fav'))
          if (!isSpecial) {
            if (!favCookie[plytyp])
              favCookie[plytyp] = {}
            favCookie[plytyp][bettyp] = {}
            if (isDelete) {
              _.unset(favCookie[plytyp], [bettyp])
              if (Object.keys(favCookie[plytyp]).length == 0) {
                _.unset(favCookie, [plytyp])
              }
            }
          } else {
            if (!favCookie.sp)
              favCookie.sp = {}
            if (!favCookie.sp[isSpecial.eveid])
              favCookie.sp[isSpecial.eveid] = {}
            if (!favCookie.sp[isSpecial.eveid][plytyp])
              favCookie.sp[isSpecial.eveid][plytyp] = {}
            favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {}
            if (isDelete) {
              _.unset(favCookie.sp[isSpecial.eveid][plytyp], [bettyp])
              if (Object.keys(favCookie.sp[isSpecial.eveid][plytyp]).length == 0) {
                _.unset(favCookie.sp[isSpecial.eveid], [plytyp])
              }
              if (Object.keys(favCookie.sp[isSpecial.eveid]).length == 0) {
                _.unset(favCookie.sp, isSpecial.eveid)
              }
            }
          }
        } else {
          if (!isSpecial) {
            favCookie[plytyp] = {}
            favCookie[plytyp][bettyp] = {}
          } else {
            favCookie.sp = {}
            favCookie.sp[isSpecial.eveid] = {}
            favCookie.sp[isSpecial.eveid][plytyp] = {}
            favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {}
          }
        }
        vueCookie.set(window.compcode + '_fav', JSON.stringify(favCookie))
      },
      getFavCookieMarket() {
        var favCookie = {}
        if (vueCookie.get(window.compcode + '_fav')) {
          favCookie = JSON.parse(vueCookie.get(window.compcode + '_fav'))
          for (var plytyp = Object.keys(favCookie).length - 1; plytyp >= 0; plytyp--) {
            var pt = Object.keys(favCookie)[plytyp]
            if (pt != 'sp') {
              for (var bettyp = Object.keys(favCookie[pt]).length - 1; bettyp >= 0; bettyp--) {
                var bt = Object.keys(favCookie[pt])[bettyp]
                if (this.$store.getters.eventAllBet.od[pt]) {
                  if (this.$store.getters.eventAllBet.od[pt][bt]) {
                    this.pickMarket(this.$store.getters.eventAllBet, pt, bt)
                  }
                }
              }
            } else {
              for (var eve = Object.keys(favCookie.sp).length - 1; eve >= 0; eve--) {
                var eveid = Object.keys(favCookie.sp)[eve]
                for (var plytyp = Object.keys(favCookie.sp[eveid]).length - 1; plytyp >= 0; plytyp--) {
                  var pt = Object.keys(favCookie.sp[eveid])[plytyp]
                  for (var bettyp = Object.keys(favCookie.sp[eveid][pt]).length - 1; bettyp >= 0; bettyp--) {
                    var bt = Object.keys(favCookie.sp[eveid][pt])[bettyp]
                    var bt = Object.keys(favCookie.sp[eveid][pt])[bettyp]['a']
                    if (this.$store.getters.eventAllBet.sp && this.$store.getters.eventAllBet.sp[eveid]) {
                      if (this.$store.getters.eventAllBet.sp[eveid].od[pt]) {
                        if (this.$store.getters.eventAllBet.sp[eveid].od[pt][bt]) {
                          this.pickMarket(this.$store.getters.eventAllBet.sp[eveid], pt, bt, true)
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return {}
      },
      pickMarket(market, plytyp, bettyp, isSpecial = false) {
        if (this.myMarketList) {
          if (!isSpecial) {
            if (!this.myMarketList.od[plytyp]) {
              this.$set(this.myMarketList.od, plytyp, {})
            }
            this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp])
          } else {
            !this.myMarketList.sp ? this.$set(this.myMarketList, 'sp', {}) : this.myMarketList.sp
            !this.myMarketList.sp[market.eveid] ? this.$set(this.myMarketList.sp, market.eveid, {}) : this.myMarketList.sp[market.eveid]
            //refresh special team info
            let copyMarket = _.cloneDeep(market)
            _.unset(copyMarket, 'od')
            _.assign(this.myMarketList.sp[market.eveid], copyMarket)
  
            !this.myMarketList.sp[market.eveid].od ? this.$set(this.myMarketList.sp[market.eveid], 'od', {}) : this.myMarketList.sp[market.eveid].od
            !this.myMarketList.sp[market.eveid].od[plytyp] ? this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {}) : this.myMarketList.sp[market.eveid].od[plytyp]
            this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp])
          }
        } else { //first pick
          this.myMarketList = _.cloneDeep(this.$store.getters.eventAllBet)
          this.$set(this.myMarketList, 'od', {})
          this.$set(this.myMarketList, 'sp', {})
          if (!isSpecial) {
            this.$set(this.myMarketList.od, plytyp, {})
            this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp])
          } else {
            this.$set(this.myMarketList.sp, market.eveid, _.cloneDeep(market))
            this.$set(this.myMarketList.sp[market.eveid], 'od', {})
            this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {})
            this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp])
          }
          this.showMyMarkets = true
        }
        !isSpecial ? this.updateFavCookie(plytyp, bettyp, false) : this.updateFavCookie(plytyp, bettyp, false, market)
        !isSpecial ? this.$delete(this.mainMarketList.od[plytyp], bettyp) : this.$delete(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp)
      },
      chooseMarketType(market, event,tab) {
  
        if (market.flag) {
          this.selectedMarket = market.key
        }
        this.switchAllBetTab(tab)
        this.openMoreBetForm(event,tab)
      },
      switchAllBetTab(tab) {
        let vue = this
        let splitId = tab.split('-').pop();

        _.forEach(vue.sportTabs[vue.selectedBettype.sprtId], function (tabkey) {
            $('.'+tabkey+'tab-'+splitId).removeClass('active');
        })
        
        $(tab).addClass('active');
      },
      widthColumn(leagueBox,column) {
        // return this.getWidthColumn()
        var widthColumn = 0
        var fm = this.$store.getters.frameWidthHeight
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount =fm.leagueTeam.columnCountBet;
        var columnCountBetShow =fm.leagueTeam.columnCountBetShow;
        var sprt = this.$store.getters.selectedBettype.sprtId
        var tmp = this.$store.getters.selectedBettype.tmpltId
        var hideCol=0;
        var extraWidth = 15 // scroll width + border use
        
        var AvailableLT = pageCenter-timeColumn-favColumn-(leagueBox? leagueBoxWidthMin:0)-extraWidth;   
        if(AvailableLT>0){
          widthColumn = AvailableLT/column
        }
        return widthColumn
      },
    },
    mounted(){
    },
    beforeMount() {
      this.allBetRefreshTimer = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 90
      this.selectedMarket = this.sportTabs[this.selectedBettype.sprtId]? this.sportTabs[this.selectedBettype.sprtId][0] : null
      this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)
      this.getFavCookieMarket()
    },
    destroyed() {
    },
  }
  </script>
  
  <style lang="scss">
  @import "~@/styles/base/global";
  // @import "~@/styles/sport/allBet/allBet";
  </style>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/more-bet-other-sport.vue